// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFirstChildOrUndefined(obj: any, childType: string): Record<string, any> | undefined {
  if (!(childType in obj)) {
    return undefined;
  }
  const r = obj[childType];

  if (r instanceof Array) {
    return r[0];
  }
  return r;
}
